import React from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { LoginViewProps } from "models/propTypes/loginPropTypes";
import { CommonConstants, IconDefinitionConstants } from "utils/constants";
import { AuthEnums } from "models/enums";
//#endregion
//#region components
import { ActionLinkButton, Icon, StyledButton, useEnterPressHandler, useMountedState } from "components/common";
import { Grid } from "@mui/material";
import useLoginContext from "./context/useLoginContext";
import UserNameLoginFormContainer from "./forms/userNameLoginFormContainer";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import clsx from "clsx";

const UserNameLogin: React.FC<LoginViewProps> = (props) => {
  const [isSubmitting, setSubmitting] = React.useState<boolean>(false);
  const formRef = React.useRef<FormHandles>(null);
  const { getMounted } = useMountedState();
  const { setLoginView } = useLoginContext();

  const toggleLoginForm = () => {
    setLoginView(AuthEnums.LoginView.BankIdApp);
  };

  const onLoginClick = () => {
    setSubmitting(true);
    return ((formRef.current && formRef.current.submit()) || new Promise<void>((resolve) => resolve())).finally(() => {
      getMounted() && setSubmitting(false);
    });
  };

  const onResetPasswordClick = () => {
    setLoginView(AuthEnums.LoginView.ForgotPassword);
  };

  useEnterPressHandler(onLoginClick);

  return (
    <>
      <Grid container className={cssExports.topContent}>
        <ActionLinkButton
          onClick={toggleLoginForm}
          startIcon={<Icon icon={IconDefinitionConstants.WChevronLeft} />}
          testId="loginWithBankIdButton"
        >
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.LoginWithBankId)}
        </ActionLinkButton>
      </Grid>
      <Grid container spacing={4}>
        <Grid container item>
          <Grid container spacing={1}>
            <Grid item container className={cssExports.loginHeader}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.Login)}
            </Grid>
            <Grid item container className={cssExports.loginMessage}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.LoginMessage)}
            </Grid>
          </Grid>
        </Grid>
        <Grid item container justifyContent="flex-start" spacing={3}>
          <Grid item container className={cssExports.loginFormContainer} spacing={0}>
            <UserNameLoginFormContainer ref={formRef} />
            <ActionLinkButton
              onClick={onResetPasswordClick}
              endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} />}
              testId="forgotPasswordButton"
            >
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.ForgotPassword)}
            </ActionLinkButton>
          </Grid>
          <Grid item container>
            <StyledButton
              type="submit"
              onClick={onLoginClick}
              className={cssExports.loginButton}
              isSubmitting={isSubmitting}
              testId="userNameLoginButton"
            >
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.Login)}
            </StyledButton>
          </Grid>
        </Grid>
      </Grid>

      <Grid container className={clsx(cssExports.bottomContent, cssExports.bottomText)}>
        <>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Login.SupportHelpText)}
          &nbsp;
          <ActionLinkButton
            href={`mailto:${CommonConstants.SupportEmailAddress}`}
            endIcon={<Icon icon={IconDefinitionConstants.WArrowSmallRight} />}
            testId="emailSupportButton"
          >
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.EmailSupport)}
          </ActionLinkButton>
        </>
      </Grid>
    </>
  );
};

export default UserNameLogin;
